 
export enum DealReturnsUnits {
    PERCENT = '%',
    DOLLAR = '$',
    X = 'x',
    BPS = 'bps',
}

export const TARGET_RETURNS_CONFIG = [
    {
        title: 'RETURN ON COST',
        field: 'cost',
        min: 0,
        unit: DealReturnsUnits.PERCENT,
    },
    {
        title: 'RETURN ON EQUITY',
        field: 'equity',
        min: 0,
        unit: DealReturnsUnits.PERCENT,
    },
    {
        title: 'PROFIT RETURN',
        field: 'profit',
        min: 0,
        max: 1000000000,
        unit: DealReturnsUnits.DOLLAR,
        hasRange: false,
    },
];

// Key stats configuration
export const KEY_STATS_CONFIG = [
    {
        title: 'IRR',
        field: 'leveredIrr',
        unit: DealReturnsUnits.PERCENT,
    },
    {
        title: 'EQUITY MULTIPLE',
        field: 'leveredEmx',
        unit: DealReturnsUnits.X,
    },
    {
        title: 'DEVELOPMENT SPREAD',
        field: 'developmentSpread',
        unit: DealReturnsUnits.BPS,
    },
    {
        title: 'RETURN ON COST',
        field: 'returnOnCost',
        unit: DealReturnsUnits.PERCENT,
    },
    {
        title: 'RETURN ON EQUITY',
        field: 'returnOnEquity',
        unit: DealReturnsUnits.PERCENT,
    },
    {
        title: 'PROFIT RETURN',
        field: 'profitReturn',
        unit: DealReturnsUnits.DOLLAR,
    },
];
